import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onLogout = () => setUser(false);
    window.addEventListener("wms-logout", onLogout);
    if (!localStorage.getItem("wms_token")) setUser(false);
    else api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    return () => window.removeEventListener("wms-logout", onLogout);
  }, []);

  const login = async (user_id, password) => {
    const r = await api.post("/auth/login", { user_id, password });
    localStorage.setItem("wms_token", r.data.token);
    setUser(r.data.user);
  };
  const logout = () => {
    localStorage.removeItem("wms_token");
    setUser(false);
  };
  const can = (p) => !!user && user.permissions.includes(p);
  return <AuthCtx.Provider value={{ user, login, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
